import "antd/dist/antd.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Card, Col, Row, Spin, Image, List, Button, Menu, Breadcrumb, Divider } from "antd";
import { useEffect, useState, useRef, useCallback } from "react";
import {
    EyeOutlined, FileTextOutlined, TagsOutlined, ArrowRightOutlined, UnlockOutlined, PlusOutlined, EditOutlined, ContactsOutlined, PlusSquareOutlined, UserOutlined, PhoneFilled, MailFilled, FileExcelOutlined, DeleteOutlined, TeamOutlined, FormOutlined, SkinOutlined, CheckOutlined
} from "@ant-design/icons";
import moment from "moment";
import { useLocation, Link, useHistory, withRouter } from "react-router-dom";

import axiosClient from "../../api/axios";
import filterDatabyKeyword from "../common/Array/filterDatabyKeyword";
import LinkUpload from "../../api/LinkUpload";




const ViewIntroduction = () => {
    const history = useHistory()
    const token = localStorage.getItem('token');
    const location = useLocation();

    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const [dataArticleAll, setDataArticleAll] = useState([])
    const [dataArticles, setDataArticles] = useState({
        "ID": 1,
        "Title": "",
        "Slug": "",
        "ArticleContent": "",
        "Sumary": "",
        "ImageUrl": "",
        "IDAuthor": 0,
        "IDCategory": 0,
        "PublishDate": "",
        "Status": 0,
        "ArticleView": 0
    });
    const LoadDataArticles = () => {
        axiosClient.post('/Articles/GetArticlesAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                const currentData = res.data.find(i => i.Slug === 'gioi-thieu')
                setDataArticles(currentData || {});
                setDataArticleAll(res.data.filter(i => i.Status === 1) || [])
                if (currentData.ID !== 0) {
                    axiosClient.post(`/Articles/IncreaseView?IDArticle=${currentData.ID}`, '', { headers: header })
                }
            }
        })
    }
    const [dataAccount, setDataAccount] = useState([])
    const LoadDataAccount = () => {
        axiosClient.post('/Accounts/SubGetAccountsAll', '', { headers: header }).then(res => {
            setDataAccount(res.data)
        })
    }
    const topArticles = dataArticleAll.sort((a, b) => b.ArticleView - a.ArticleView).slice(0, 5);
    const newArticles = dataArticleAll.sort((a, b) => a.ArticleView - b.ArticleView).slice(0, 5);

    const [dataArticleTags, setDataArticleTags] = useState([])
    const LoadDataArticleTags = () => {
        axiosClient.post('/ArticleTags/GetArticleTagsAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataArticleTags(res.data);
            }
        })
    }
    const [dataTags, setDataTags] = useState([])
    const LoadDataTags = () => {
        axiosClient.post('/Tags/GetTagsAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataTags(res.data);
            }
        })
    }
    const [dataCategory, setDataCategory] = useState([])
    const LoadDataCategory = () => {
        axiosClient.post('/Categories/GetCategoriesAll', '', {
            headers: header
        }).then(resCate => {
            setDataCategory(resCate.data)
        })
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        LoadDataCategory()
        LoadDataArticleTags()
        LoadDataAccount()
        LoadDataTags()
        LoadDataArticles()

    }, [])



    const getNamebySlugArticle = (dataArticle, dataArticleTags, dataTags) => {
        // Lọc danh sách IDTag từ dataTags dựa trên IDArticle của dataArticle
        const listTag = dataArticleTags.filter(i => i.IDArticle === dataArticle.ID).map(r => r.IDTag);

        // Trả về danh sách các thẻ <a> với tên tags nối bằng dấu phẩy
        return listTag.length > 0 ? (
            listTag
                .map(r => {
                    const tagName = dataTags.find(i => i.ID === Number(r))?.Name; // Lấy tên tag theo IDTag
                    return tagName ? (
                        <a key={r} style={{ color: '#FF8411', marginRight: '5px' }} href={dataTags.find(i => i.ID === Number(r))?.Slug !== '' ? '/view/' + dataTags.find(i => i.ID === Number(r))?.Slug : ''}>
                            {tagName}
                        </a>
                    ) : null;
                })
                .reduce((prev, curr, index) => [
                    prev,
                    index > 0 && ', ',  // Thêm dấu phẩy giữa các thẻ a
                    curr
                ])  // Kết quả cuối cùng sẽ là một mảng các thẻ <a> nối với nhau bởi dấu phẩy
        ) : null; // Nếu không có tags, trả về null
    }

    const dataBanner = [
        {
            src: 'https://luatsuhanoi.vn/wp-content/uploads/2022/08/baove.png',
        },
        {
            src: 'https://luatsuhanoi.vn/wp-content/uploads/2022/12/sl4.jpg',
        },
        {
            src: 'https://luatsuhanoi.vn/wp-content/uploads/2022/08/baove.png',
        },
        {
            src: 'https://luatsuhanoi.vn/wp-content/uploads/2022/09/lich-hop.jpg',
        },
    ]
    const replaceLinksWithIframe = (content) => {
        // Biểu thức chính quy để tìm các liên kết Google Drive
        const regex = /<a href="https:\/\/drive.google.com\/file\/d\/([^\/]+)\/preview"[^>]*>https:\/\/drive.google.com\/file\/d\/\1\/preview<\/a>/g;

        // Thay thế thẻ <a> bằng <iframe>
        return content.replace(regex, (match, fileId) => {
            return `<iframe src="https://drive.google.com/file/d/${fileId}/preview" width="100%" height="500px" allow="autoplay"></iframe>`;
        });
    };
    const renderBodyHtml = (content) => {
        const data = `
            <html>
            <head>
                <style>
           .reviewContainer img {
    width: 100%;       /* Đảm bảo hình ảnh không vượt quá chiều rộng của phần tử chứa */
                max-width: 100%;   /* Hạn chế chiều rộng tối đa của hình ảnh */
                height: auto;      /* Giữ tỉ lệ hình ảnh */
                display: block;    /* Loại bỏ khoảng cách thừa dưới hình ảnh */
                object-fit: cover;
}

                
                </style>
            </head>
            <div class="reviewContainer">
    ${replaceLinksWithIframe(content)}
</div>
           
            </html>
        `
        return data
    }

    function getNameByIdCategory(id) {
        const category = dataCategory.find(item => item.ID === id);
        return category ? category.Name : null;  // If found, return Name, else return null
    }

    return (
        <div style={{ backgroundColor: 'white' }}>
            <Row gutter={[10, 10]}>
                <Col xs={24} xl={18} span={18}>
                    <Card bordered={false} title={<Breadcrumb separator=">>">
                        <Breadcrumb.Item>Trang chủ</Breadcrumb.Item>
                        <Breadcrumb.Item href="">Tin hoạt động</Breadcrumb.Item>
                        <Breadcrumb.Item href="">{dataArticles.Sumary}</Breadcrumb.Item>

                    </Breadcrumb>}>
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col style={{ fontSize: 26, fontWeight: 700, color: 'red' }} span={24}>
                                        {dataArticles.Sumary}
                                    </Col>
                                    <Col style={{ fontSize: 16, fontWeight: 500, color: '#7A6666', fontFamily: 'Quicksand' }} span={24}>
                                        <FileTextOutlined style={{ color: '#FF8411', fontSize: 16 }} /> {moment(dataArticles.PublishDate).format('DD-MM-YYYY')}<Divider type="vertical" /><UserOutlined style={{ color: '#FF8411', fontSize: 16 }} /> {dataAccount.filter(i => i.ID === dataArticles.IDAuthor).map(r => r.FullName)} <Divider type="vertical" /><EyeOutlined style={{ color: '#FF8411', fontSize: 16 }} /> {dataArticles.ArticleView + 1} lượt xem
                                    </Col>
                                    <Col span={24}>
                                        <br />
                                    </Col>
                                </Row>
                            </Col>
                            <Col style={{ borderBottom: '1px solid #F0F2F5', fontSize: 16 }} dangerouslySetInnerHTML={{ __html: renderBodyHtml(dataArticles.ArticleContent) }} span={24}>

                            </Col>
                            <Col span={24}>
                                <Card bordered={false} title={dataArticleTags.filter(i => i.IDArticle === dataArticles.ID).length > 0 ? <span style={{ fontSize: 14, fontStyle: 'normal' }}>
                                    <span>
                                        <TagsOutlined style={{ fontSize: 20, color: '#FF8411' }} /> {getNamebySlugArticle(dataArticles, dataArticleTags, dataTags)}
                                    </span>
                                </span> : null}>
                                    <Row>




                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Card>

                </Col>
                <Col xs={24} xl={6} style={{ paddingTop: 20 }} span={6}>
                    <Row>
                        <Col span={24}>
                            <Card bodyStyle={{ margin: 0, padding: 0 }} bordered={false} headStyle={{ fontWeight: 700, backgroundColor: '#B20000', color: 'white' }} title={String(getNameByIdCategory(2)).toUpperCase()}>
                                <List
                                    dataSource={dataArticleAll.filter(i => i.IDCategory === 2).sort((a, b) => b.ID - a.ID).slice(0, 5)}
                                    renderItem={item => (
                                        <List.Item onClick={(e) => history.push(`/view/${item.Slug}`)}>
                                            <a style={{ color: '#B20000', fontWeight: 400, fontSize: 14 }}>{item.Sumary}</a>
                                        </List.Item>
                                    )}
                                />
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card style={{ backgroundColor: '#EFEFEF' }} bordered={false} headStyle={{ fontWeight: 700, backgroundColor: '#B20000', color: 'white' }} title='BÀI XEM NHIỀU NHẤT'>
                                <List
                                    dataSource={topArticles}
                                    renderItem={item => (
                                        <List.Item onClick={(e) => history.push(`/view/${item.Slug}`)}>
                                            <a style={{ color: '#B20000', fontWeight: 400, fontSize: 14 }}>{item.Sumary}</a>
                                        </List.Item>
                                    )}
                                />
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card style={{ backgroundColor: '#EFEFEF' }} bordered={false} headStyle={{ fontWeight: 700, backgroundColor: '#B20000', color: 'white' }} title='BÀI VIẾT MỚI NHẤT'>
                                <List
                                    dataSource={newArticles}
                                    renderItem={item => (
                                        <List.Item onClick={(e) => history.push(`/view/${item.Slug}`)}>
                                            <a style={{ color: '#B20000', fontWeight: 400, fontSize: 14 }}>{item.Sumary}</a>
                                        </List.Item>
                                    )}
                                />
                            </Card>
                        </Col>
                        <Col span={24}>
                            <List

                                bordered={false}
                                grid={{
                                    gutter: 10, column: 1
                                }}
                                dataSource={dataBanner}
                                renderItem={item => (
                                    <List.Item >
                                        <Image className="image-container" preview={false} src={item.src} />
                                    </List.Item>
                                )}
                            />
                        </Col>
                    </Row>

                </Col>
            </Row>


        </div >

    )
}
export default ViewIntroduction;